/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskDimension } from './RiskDimension';
import { RiskDimensionFromJSON, RiskDimensionFromJSONTyped, RiskDimensionToJSON } from './RiskDimension';
import type { RiskDimensionLabel } from './RiskDimensionLabel';
import {
  RiskDimensionLabelFromJSON,
  RiskDimensionLabelFromJSONTyped,
  RiskDimensionLabelToJSON,
} from './RiskDimensionLabel';

/**
 *
 * @export
 * @interface PatchedRiskProfileDimensionRisk
 */
export interface PatchedRiskProfileDimensionRisk {
  /**
   *
   * @type {number}
   * @memberof PatchedRiskProfileDimensionRisk
   */
  readonly id?: number;
  /**
   *
   * @type {RiskDimension}
   * @memberof PatchedRiskProfileDimensionRisk
   */
  readonly dimension?: RiskDimension;
  /**
   *
   * @type {RiskDimensionLabel}
   * @memberof PatchedRiskProfileDimensionRisk
   */
  readonly calculatedRiskLabel?: RiskDimensionLabel;
  /**
   *
   * @type {RiskDimensionLabel}
   * @memberof PatchedRiskProfileDimensionRisk
   */
  overrideRiskLabel?: RiskDimensionLabel;
}

/**
 * Check if a given object implements the PatchedRiskProfileDimensionRisk interface.
 */
export function instanceOfPatchedRiskProfileDimensionRisk(value: object): value is PatchedRiskProfileDimensionRisk {
  return true;
}

export function PatchedRiskProfileDimensionRiskFromJSON(json: any): PatchedRiskProfileDimensionRisk {
  return PatchedRiskProfileDimensionRiskFromJSONTyped(json, false);
}

export function PatchedRiskProfileDimensionRiskFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedRiskProfileDimensionRisk {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    dimension: json['dimension'] == null ? undefined : RiskDimensionFromJSON(json['dimension']),
    calculatedRiskLabel:
      json['calculated_risk_label'] == null ? undefined : RiskDimensionLabelFromJSON(json['calculated_risk_label']),
    overrideRiskLabel:
      json['override_risk_label'] == null ? undefined : RiskDimensionLabelFromJSON(json['override_risk_label']),
  };
}

export function PatchedRiskProfileDimensionRiskToJSON(
  value?: Omit<PatchedRiskProfileDimensionRisk, 'id' | 'dimension' | 'calculatedRiskLabel'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    override_risk_label: RiskDimensionLabelToJSON(value['overrideRiskLabel']),
  };
}
